import React from "react"
import { Paper, styled } from "@mui/material";

const StyledHeader = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.h2,
    display: 'flex',
    color: theme.palette.text.primary,
    boxShadow: 'none',
    fontSize: '36px',
    paddingLeft: '12px',
    paddingBottom: '12px'
}));

const SectionHeader = (props) => {
  const { title, component } = props

  return (
    <StyledHeader component={component}>{title}</StyledHeader>
  );
}

export default SectionHeader
